"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.infraEnvsReducer = exports.infraEnvsActions = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
// This slice holds a list of infra-envs where each one has a different cpuArchitecture.
// There should be no repetitions.
const infraEnvsSlice = (0, toolkit_1.createSlice)({
    name: 'infraEnvs',
    initialState: [],
    reducers: {},
});
exports.infraEnvsActions = infraEnvsSlice.actions;
exports.infraEnvsReducer = infraEnvsSlice.reducer;
//# sourceMappingURL=slice.js.map